<template>
  <svg version="1.1" class="table-config-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 35 35" width="22px" height="22px" style="enable-background:new 0 0 35 35;" xml:space="preserve">
    <path d="M8.553,27.017c-.552,0-1-.447-1-1V10.016c0-.552.448-1,1-1s1,.448,1,1v16c0,.553-.448,1-1,1ZM16.012,26.017V10.016c0-.552-.448-1-1-1s-1,.448-1,1v16c0,.553.448,1,1,1s1-.447,1-1ZM28.932,25.017v-14c0-1.103-.897-2-2-2h-4.46c-1.103,0-2,.897-2,2v14c0,1.103.897,2,2,2h4.46c1.103,0,2-.897,2-2ZM26.932,11.016v14h-4.46v-14h4.46Z"/>
  </svg>
</template>
